import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/common/PageHeader';
import { DataTable } from '../../components/common/DataTable';
import { useOrgsList } from '../../hooks/useOrganizations';
import dayjs from 'dayjs';
import type { AdminOrgListItem } from '../../types/organizations';
import type { ColumnsType } from 'antd/es/table';

export function OrgsListPage() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, per_page: 20, search: '' });
  const { data, isLoading } = useOrgsList(params);

  const columns: ColumnsType<AdminOrgListItem> = [
    { title: 'Name', dataIndex: 'name', key: 'name', render: (v: string, r) => <a onClick={() => navigate(`/organizations/${r.id}`)}>{v}</a> },
    { title: 'Owner', dataIndex: 'owner_email', key: 'owner_email' },
    { title: 'Members', dataIndex: 'member_count', key: 'member_count', align: 'right' },
    { title: 'Plan', dataIndex: 'plan_tier', key: 'plan_tier', render: (v: string | null) => v || '-' },
    { title: 'Created', dataIndex: 'created_at', key: 'created_at', render: (v: string) => dayjs(v).format('MMM D, YYYY') },
  ];

  return (
    <>
      <PageHeader title="Organizations" subtitle={`${data?.total ?? 0} total`} />
      <DataTable<AdminOrgListItem>
        columns={columns}
        dataSource={data?.data}
        loading={isLoading}
        total={data?.total}
        page={params.page}
        perPage={params.per_page}
        onPageChange={(p, ps) => setParams((s) => ({ ...s, page: p, per_page: ps }))}
        onSearch={(v) => setParams((s) => ({ ...s, search: v, page: 1 }))}
        searchPlaceholder="Search organizations..."
      />
    </>
  );
}
